import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { getUserAccount, updateUserBalance } from '../../services/userServices';
import { toAuthState } from '../../dto/auth.dto';

const initialState = {
  isLoading: false,
  isAuthenticated: false,
  account: {},
  userData: {},
};

export const fetchUserAccount = createAsyncThunk(
  'user/fetchUserAccount',
  async (_, { rejectWithValue }) => {
    try {
      const state = toAuthState(await getUserAccount());
      return state || rejectWithValue({ isAuthenticated: false });
    } catch (error) {
      return rejectWithValue({ isAuthenticated: false });
    }
  },
);

export const updateBalance = createAsyncThunk(
  'user/updateBalance',
  async ({ ewalletId, amount }, { rejectWithValue }) => {
    const response = await updateUserBalance(ewalletId, amount);
    return response?.ok ? response.data : rejectWithValue('Không thể cập nhật số dư');
  },
);

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    login: (_, action) => action.payload,
    logout: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchUserAccount.pending, (state) => { state.isLoading = true; })
      .addCase(fetchUserAccount.fulfilled, (_, action) => action.payload)
      .addCase(fetchUserAccount.rejected, () => initialState)
      .addCase(updateBalance.fulfilled, (state, action) => {
        const amount = Number(action.meta.arg.amount || 0);
        if (state.userData?.userData && Number.isFinite(amount)) {
          state.userData.userData.balance = Number(state.userData.userData.balance || 0) + amount;
        }
      });
  },
});

export const { login, logout } = userSlice.actions;
export default userSlice.reducer;
